import { assign } from 'fsm';
import { fetchTemplates } from './client';
import { shuffleArray } from './util';
import { TEMPLATES_COUNT } from './constants';
import { wait } from '../../utils';
export const machine = {
  initial: 'loadingTemplates',
  states: {
    loadingTemplates: {
      invoke: {
        src: 'fetchTemplates',
        onDone: [{
          target: 'idle',
          actions: ['setTemplates', 'setTemplatesForDisplay']
        }],
        onError: [{
          target: 'error'
        }]
      },
      tags: ['loading']
    },
    refreshingTemplates: {
      invoke: {
        src: 'wait',
        onDone: [{
          target: 'idle',
          actions: ['setTemplatesForDisplay']
        }]
      },
      tags: ['loading']
    },
    idle: {
      on: {
        REFRESH: {
          target: 'refreshingTemplates'
        },
        RETRY: {
          target: 'loadingTemplates'
        }
      }
    },
    error: {
      on: {
        REFRESH: 'loadingTemplates'
      },
      tags: ['error']
    }
  },
  actions: {
    setTemplates: assign((_context, event) => {
      const {
        data
      } = event || {};
      return {
        templates: data
      };
    }),
    setTemplatesForDisplay: assign(context => {
      const {
        templates
      } = context;
      return {
        templatesForDisplay: shuffleArray(templates).slice(0, TEMPLATES_COUNT)
      };
    }),
    setErrorId: assign((_context, event) => {
      const {
        responseJSON
      } = event.data;
      const {
        correlationId
      } = responseJSON;
      return {
        errorId: correlationId
      };
    })
  },
  services: {
    fetchTemplates,
    wait: async () => {
      await wait(700);
    }
  }
};